export default "__VITE_ASSET__ce74F5Kw__"